import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { setToken } from '../utils/auth';
import './Login.css';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [otp, setOtp] = useState('');
    const [loginType, setLoginType] = useState('customer'); // 'customer' or 'admin'
    const [step, setStep] = useState('email'); // 'email' or 'otp'
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const handleRequestOTP = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setLoading(true);

        try {
            const response = await authAPI.requestOTP(email);
            setMessage(response.data.message);
            setStep('otp');
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to send OTP');
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOTP = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setLoading(true);

        try {
            const response = await authAPI.verifyOTP(email, otp);
            setToken(response.data.data.token);
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to verify OTP');
        } finally {
            setLoading(false);
        }
    };

    const handleAdminLogin = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setLoading(true);

        try {
            const response = await authAPI.loginWithPassword(email, password);
            setToken(response.data.data.token);
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.message || 'Invalid credentials');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <h1>Scanner API</h1>

                <div className="login-type-toggle">
                    <button
                        className={loginType === 'customer' ? 'active' : ''}
                        onClick={() => {
                            setLoginType('customer');
                            setStep('email');
                            setError('');
                            setMessage('');
                            setPassword('');
                        }}
                        type="button"
                        disabled={loading}
                    >
                        Customer Login
                    </button>
                    <button
                        className={loginType === 'admin' ? 'active' : ''}
                        onClick={() => {
                            setLoginType('admin');
                            setStep('email');
                            setError('');
                            setMessage('');
                            setOtp('');
                        }}
                        type="button"
                        disabled={loading}
                    >
                        Admin Login
                    </button>
                </div>

                {loginType === 'admin' ? (
                    <form onSubmit={handleAdminLogin}>
                        <h2>Admin Login</h2>
                        {error && <div className="error">{error}</div>}
                        {message && <div className="success">{message}</div>}

                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="admin@example.com"
                                required
                                disabled={loading}
                            />
                        </div>

                        <div className="form-group">
                            <label>Password</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter your password"
                                required
                                disabled={loading}
                            />
                        </div>

                        <button type="submit" disabled={loading}>
                            {loading ? 'Logging in...' : 'Login'}
                        </button>
                    </form>
                ) : step === 'email' ? (
                    <form onSubmit={handleRequestOTP}>
                        <h2>Customer Login</h2>
                        {error && <div className="error">{error}</div>}
                        {message && <div className="success">{message}</div>}

                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                required
                                disabled={loading}
                            />
                        </div>

                        <button type="submit" disabled={loading}>
                            {loading ? 'Sending...' : 'Send OTP'}
                        </button>
                    </form>
                ) : (
                    <form onSubmit={handleVerifyOTP}>
                        <h2>Enter OTP</h2>
                        {error && <div className="error">{error}</div>}
                        {message && <div className="success">{message}</div>}

                        <p className="info-text">
                            We've sent a 6-digit code to <strong>{email}</strong>
                        </p>

                        <div className="form-group">
                            <label>OTP Code</label>
                            <input
                                type="text"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                placeholder="Enter 6-digit code"
                                maxLength="6"
                                pattern="[0-9]{6}"
                                required
                                disabled={loading}
                                autoFocus
                            />
                        </div>

                        <button type="submit" disabled={loading}>
                            {loading ? 'Verifying...' : 'Verify & Login'}
                        </button>

                        <button
                            type="button"
                            className="secondary"
                            onClick={() => {
                                setStep('email');
                                setOtp('');
                                setError('');
                                setMessage('');
                            }}
                            disabled={loading}
                        >
                            Back
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}

export default Login;
